import {
  FETCH_DATA_ME_DEPENDENCIES_REQUEST,
  FETCH_DATA_ME_DEPENDENCIES_SUCCESS,
  FETCH_DATA_ME_DEPENDENCIES_FAILURE,
} from "../../actions/entities/get-dependencies-action";

const initialState = {
  dependencies: null,
  isLoading: false,
  error: null,
};

const MeDependenciesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_DATA_ME_DEPENDENCIES_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_DATA_ME_DEPENDENCIES_SUCCESS:
      console.log("FETCH_DATA_ME_DEPENDENCIES_SUCCESS", action.payload);
      return {
        ...state,
        isLoading: false,
        dependencies: action.payload,
      };
    case FETCH_DATA_ME_DEPENDENCIES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default MeDependenciesReducer;
